/* eslint-disable no-param-reassign */
import { ArrowLeftOutlined, DeleteOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Form,
  message,
  Row,
  Spin,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import FormSubmitCustomControls from 'components/FormSubmitCustomControls';
import InfoPadron from 'components/PadronesInfo';
import React, { useMemo, useState } from 'react';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';

// Componentes locales
import { onError } from 'utils/handlers';
import FormBusqueda from './components/FormBusqueda';
import FormCargo from './components/FormCargo';
import FormGasto from './components/FormGasto';
import TablaCargos from './components/TablaCargos';
import TablaGastos from './components/TablaGastos';

// Hooks y utilidades
import useGastos from './hooks/useGastos';
import { getFormRules } from './utils/formRules';
import { getColumnsCargos, getColumnsGastos } from './utils/tableColumns';

// eslint-disable-next-line react/prop-types
const GastosRefactorizado = ({ permission }) => {
  const {
    // Estado
    loading,
    loadingMessage,
    tipoDePadronSelected,
    setTipoDePadronSelected,
    selectedRowKeys,
    selectedRowKeysGastos,
    visibleBusquedaPadrones,
    setVisibleBusquedaPadrones,
    visible,
    visibleForm,
    dataExterno,
    setDataExterno,
    padron,
    setPadron,
    gastos,
    hasAllViewPermission,
    tiposDeGastos,
    cargos,
    padron_principal,
    padrones,
    collapsedSidebar,
    estadosGlobales,
    moneda,
    setVisibleForm,
    setVisible,

    // Métodos
    normalizePadron,
    handleSearchPadron,
    onFinishGasto,
    asignarEntidad,
    onCancelGasto,
    onClickExpand,
    onClickExpandGasto,
    onClickAdd,
    handleOnRowClick,
    handleOnRowClickGasto,
    onClear,
    onCancelCargo,
    handleOnCancelGasto: handleOnCancelGastoAplicado,
    ConfirmModal,
  } = useGastos();

  const [variables, setVariables] = useState([]);

  // Formularios
  const [form] = Form.useForm();
  const [formCargo] = Form.useForm();
  const [formGasto] = Form.useForm();

  // Reglas de validación
  const rules = useMemo(
    () => getFormRules(moneda, tiposDeGastos, formGasto),
    [moneda, tiposDeGastos, formGasto],
  );

  // Columnas de tablas
  const columns = useMemo(() => getColumnsCargos(), []);
  const columnsGasto = useMemo(() => getColumnsGastos(estadosGlobales), [estadosGlobales]);

  // Selección de filas
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const rowSelectionGasto = {
    selectedRowKeys: selectedRowKeysGastos,
    type: 'radio',
  };

  // Handlers
  const onFinish = async () => {
    try {
      await form.validateFields();
      handleSearchPadron(form);
    } catch (err) {
      onError(err);
    }
  };

  const handleOnFinishGasto = () => onFinishGasto(formGasto, variables);

  const handleOnClickExpand = () => onClickExpand(null, cargos, formCargo);

  const handleOnClickExpandGasto = () => onClickExpandGasto(formGasto);

  const handleOnClear = () => onClear(form);

  const handleOnCancelCargo = () => onCancelCargo(formCargo);

  const handleOnCancelGasto = () => {
    onCancelGasto();
  };

  const msgAsignarEntidad = (user) => (
    message.info({
      content: (
        <>
          <Row style={{ width: '100%' }}>
            El contribuyente no pertenece a la entidad.
          </Row>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              ¿Desea asignarlo a esta entidad?
            </strong>
          </Row>
          <Row align="middle" justify="center" style={{ width: '100%' }}>
            <Button
              type="link"
              onClick={() => asignarEntidad(user)}
            >
              Si
            </Button>
            <Button
              onClick={() => {
                message.destroy();
                form.resetFields();
              }}
              type="link"
            >
              No
            </Button>
          </Row>
        </>
      ),
      duration: 0,
    })
  );

  const getTitle = () => {
    if (visibleForm) {
      return `${!selectedRowKeysGastos.length ? 'Agregar ' : ''}Gasto`;
    }
    if (visible) {
      return 'Cargo';
    }
    if (padron) {
      return 'Padrón';
    }
    return 'Búsqueda del Padrón';
  };

  const getControls = () => {
    if (visibleForm) {
      return (
        <FormSubmitControls
          onFinish={handleOnFinishGasto}
          onCancel={handleOnCancelGasto}
          permission={permission}
        />
      );
    }
    const controls = [];
    if (visible) {
      controls.push({
        text: 'Regresar',
        icon: <ArrowLeftOutlined />,
        onClick: handleOnCancelCargo,
      });
    } else {
      controls.push({
        text: 'Limpiar Búsqueda',
        icon: <DeleteOutlined />,
        onClick: handleOnClear,
      });
    }
    return (
      <FormSubmitCustomControls controls={controls} />
    );
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip={loadingMessage || 'Cargando...'} spinning={loading}>
        <Card
          className="form-container"
          title={getTitle()}
          bordered={false}
          extra={getControls()}
        >
          {(!visible && !visibleForm) && (
            <>
              <InfoPadron padron={padron} tipoDePadron={tipoDePadronSelected} />
              <FormBusqueda
                form={form}
                padron={padron}
                tipoDePadronSelected={tipoDePadronSelected}
                setTipoDePadronSelected={setTipoDePadronSelected}
                onFinish={onFinish}
                rules={rules}
                collapsedSidebar={collapsedSidebar}
                visibleBusquedaPadrones={visibleBusquedaPadrones}
                setVisibleBusquedaPadrones={setVisibleBusquedaPadrones}
                dataExterno={dataExterno}
                setDataExterno={setDataExterno}
                padron_principal={padron_principal}
                padrones={padrones}
              />
              <br />
              <TablaCargos
                cargos={cargos}
                columns={columns}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                onClickExpand={handleOnClickExpand}
                hasAllViewPermission={hasAllViewPermission}
                permission={permission}
              />
            </>
          )}
          {(visible && !visibleForm) && (
            <>
              <FormCargo formCargo={formCargo} />
              <br />
              <TablaGastos
                gastos={gastos}
                columnsGasto={columnsGasto}
                rowSelectionGasto={rowSelectionGasto}
                handleOnRowClickGasto={handleOnRowClickGasto}
                onClickExpandGasto={handleOnClickExpandGasto}
                onClickAdd={() => onClickAdd(formGasto)}
                hasAllViewPermission={hasAllViewPermission}
                permission={permission}
                handleOnCancelGasto={handleOnCancelGastoAplicado}
              />
            </>
          )}
          {visibleForm && (
            <FormGasto
              formGasto={formGasto}
              tiposDeGastos={tiposDeGastos}
              rules={rules}
              selectedRowKeysGastos={selectedRowKeysGastos}
              setVariables={setVariables}
              variables={variables}
              onFinishGasto={handleOnFinishGasto}
              setVisible={setVisible}
              setVisibleForm={setVisibleForm}
              handleOnCancelGasto={handleOnCancelGasto}
              isEdit={!!selectedRowKeysGastos.length}
            />
          )}
        </Card>
      </Spin>
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPadrones}
        setVisible={setVisibleBusquedaPadrones}
        callback={(pdrn) => setPadron(normalizePadron(pdrn))}
        dataExterno={dataExterno}
        setDataExterno={setDataExterno}
        tipoDePadron={tipoDePadronSelected}
        msgAsignarEntidad={msgAsignarEntidad}
      />
      <ConfirmModal />
    </Row>
  );
};

export default GastosRefactorizado;
